export default "__VITE_ASSET__1339f367__"